import { createContext, useState, useEffect } from "react";
import { jwtDecode } from "jwt-decode";
// useNavigate was imported but not used, so I've removed it for cleanup.
// If you use it elsewhere in this file, you can re-add it.

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [authData, setAuthData] = useState(null);
  // const [user, setUser] = useState(null); // <-- REMOVED

  // This logic should only run once on mount
  useEffect(() => {
    const storedAuthData = localStorage.getItem("authData");
    if (storedAuthData) {
      const parsedData = JSON.parse(storedAuthData);
      
      // --- ADDED THIS CHECK ---
      try {
        const decodedToken = jwtDecode(parsedData.jwtToken);
        if (decodedToken.exp * 1000 < Date.now()) {
          // Token is expired
          logoutUser(); // Call logout to clear state
        } else {
          // Token is valid, set state
          setAuthData(parsedData);
          // setUser(parsedData.userData); // <-- REMOVED
        }
      } catch (error) {
        // Token is invalid
        console.error("Invalid token:", error);
        logoutUser();
      }
      // --- END OF CHECK ---
    }
  }, []); 

  const loginUser = (userData, jwtToken, role = "auth") => {
    const dataToStore = { userData, jwtToken, role };
    setAuthData(dataToStore);
    // setUser(userData); // <-- REMOVED
    localStorage.setItem("authData", JSON.stringify(dataToStore));
  };

  const logoutUser = () => {
    setAuthData(null);
    // setUser(null); // <-- REMOVED
    localStorage.removeItem("authData");
  };

  // Create the user object on the fly from authData
  const user = authData?.userData || null;

  return (
    <AuthContext.Provider value={{ authData, user, loginUser, logoutUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
